import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%","display":"flex"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("配置")

import { defineComponent, ref, reactive, nextTick, onMounted } from 'vue';
import { useRoute, useRouter } from "vue-router"
import request from '@/plugin/request';
import { NCard, NGrid, NGridItem, NButton, NSpace } from 'naive-ui'


export default _defineComponent({
  setup(__props) {

nextTick(() => {

})

onMounted(() => {



})

const route = useRoute();
const router = useRouter();

const cardList = ref([
    {
        title: '报表权限配置',
        ver: 210926,
        desc: '配置企业微信内手机报表权限',
        url: '/Configure/FineReport'
    },
    {
        title: '手机权限配置',
        ver: 211018,
        desc: '配置企业微信内伯俊报表权限',
        url: '/Configure/MobileReport'
    }
])

const handleSelect = (url: string) => {
    console.log(url)
    router.push(url)

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_unref(NGrid), {
      cols: "4 s:2 m:4 l:4 xl:4 ",
      "x-gap": 12,
      "y-gap": 12,
      responsive: "screen"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(cardList.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(NGridItem), { key: index }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), {
                title: item.title
              }, {
                "header-extra": _withCtx(() => [
                  _createTextVNode(" Ver:" + _toDisplayString(item.ver), 1)
                ]),
                action: _withCtx(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_unref(NButton), {
                      type: "info",
                      style: {"flex":"1"},
                      onClick: ($event: any) => (handleSelect(item.url))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(item.desc) + " ", 1)
                ]),
                _: 2
              }, 1032, ["title"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})